import React from 'react';
import BuyNow from './BuyNow';
import './TopStories.less';

const TopStories = ({ banner, isMobile }) => {
  return (
    <div key={banner.order_index} className="hero_banner">
      <div className="hero_image">
        <img
          alt=""
          src={isMobile
            ? banner.images.hero_banner_mobile
            : banner.images.hero_banner_desktop}
        />
      </div>
      <div
        className={banner.has_gradient ? 'gradient_overlay' : ''}
        style={{ backgroundImage: `linear-gradient(transparent 70%, ${banner.gradient_color})` }}
      />
      <div className="banner_info">
        <div
          className="banner_title"
          style={{ color: banner.description.colorText }}
        >
          {banner.description.text}
        </div>
        <BuyNow banner={banner} />
      </div>
    </div>
  );
};

export default TopStories;
